import { Row, Col, Card, Table, Button, Input, Tag, Tooltip, Image, Select } from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../../../hooks/useRequest";
import ShowTotal from "../../../components/ShowTotal";
import { ShowToast, Severty } from "../../../helper/toast";
import useDebounce from "../../../hooks/useDebounce";
import { useNavigate } from "react-router";
import ConfirmationBox from "../../../components/ConfirmationBox";
import apiPath from "../../../constants/apiPath";
import notfound from "../../../assets/images/not_found.png";
import ImportForm from "../../../components/ImportForm";
import { DownloadExcel, SampleFileDownload } from "../../../components/ExcelFile";
import moment from 'moment';
import { Link } from "react-router-dom";
import { ViewDealer } from "./ViewDealer";

const Search = Input.Search;

function Index() {

  const sectionName = "Product";
  const routeName = "product/catalogue";

  const api = {
    status: apiPath.statusProduct,
    list: apiPath.listProduct,
    importFile: apiPath.importProduct,
    category: apiPath.categoryList,
    viewProductDealer: apiPath.viewProductDealer,
  }

  const [searchText, setSearchText] = useState('');
  const { request } = useRequest()
  const [list, setList] = useState([])
  const { showConfirm } = ConfirmationBox()
  const [loading, setLoading] = useState(false)
  const [importVisible, setImportVisible] = useState(false);
  const [refresh, setRefresh] = useState(false)
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const debouncedSearchText = useDebounce(searchText, 300);
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState();
  const [categoryList, setCategoryList] = useState([])
  const [categoryIds, setCategoryIds] = useState([]);

  const viewDealer = (id) => {
    if (id) {
      setVisible(true)
    }
  };

  const columns = [
    {
      title: "Thumbnail",
      dataIndex: "thumbnail",
      key: "thumbnail",
      render: (_, { thumbnail, image }) => <Image width={50} src={thumbnail ? thumbnail : image ? image[0] : notfound} />
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (_, { name }) => {
        return name ? <span className="cap">{name}</span> : '-';
      },
      sorter: (a, b) => {
        let nameA = a.name.toLowerCase();
        let nameB = b.name.toLowerCase();
        if (nameA < nameB)
          return -1;
        if (nameA > nameB)
          return 1;
        return 0;
      },
    },
    /* {
      title: "Brand",
      dataIndex: "brand",
      key: "brand",
      render: (_, { brand }) => {
        return brand && brand.name ? <span className="cap">{brand.name}</span> : '-';
      },
      sorter: (a, b) => {
        let nameA = a.brand.name.toLowerCase();
        let nameB = b.brand.name.toLowerCase();
        if (nameA < nameB)
          return -1;
        if (nameA > nameB)
          return 1;
        return 0;
      },
    }, */
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      render: (_, { category }) => {
        return category && category.name ? <span className="cap">{category.name}</span> : '-';
      },
      sorter: (a, b) => {
        let nameA = a.category.name.toLowerCase();
        let nameB = b.category.name.toLowerCase();
        if (nameA < nameB)
          return -1;
        if (nameA > nameB)
          return 1;
        return 0;
      },
    },
    {
      title: "Part Number",
      dataIndex: "part_number",
      key: "part_number",
      render: (_, { part_number }) => {
        return part_number ? <span className="cap">{part_number}</span> : '-';
      },
      sorter: (a, b) => {
        let nameA = a.part_number;
        let nameB = b.part_number;
        if (nameA < nameB)
          return -1;
        if (nameA > nameB)
          return 1;
        return 0;
      },
    },
    {
      title: "Status",
      key: "is_active",
      filters: [
        {
          text: 'Active',
          value: true,
        },
        {
          text: 'Inactive',
          value: false,
        },
      ],
      render: (_, { is_active, _id }) => {
        let color = is_active ? 'green' : 'red';
        return (<a><Tag onClick={(e) => showConfirm({ record: _id, path: api.status, onLoading: () => setLoading(true), onSuccess: () => setRefresh(prev => !prev) })} color={color} key={is_active}>{is_active ? "Active" : "Inactive"}</Tag></a>);
      },
    },
    {
      title: "Created On",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return (
          moment(created_at).format('DD-MMM-YYYY')
        );
      },
      sorter: (a, b) => {
        if (a.created_at < b.created_at) {
          return -1;
        }
        else if (a.created_at > b.created_at) {
          return 1;
        }
        return 0;
      }
    },
    {
      title: "Action",
      fixed: 'right',
      render: (_, record) => {
        return (
          <>
            <Tooltip title={"Update " + sectionName} color={"purple"} key={"update" + routeName}>
              <Link className="ant-btn ant-btn-default" title="Edit" to={`/pimptup-admin/${routeName}/update/` + (record ? record._id : null)}><i className="fa fa-light fa-pen"></i>
              </Link>
            </Tooltip>

            <Tooltip title={"View " + sectionName} color={"purple"} key={"view" + routeName}>
              <Link className="ant-btn ant-btn-default" title="View" to={`/pimptup-admin/${routeName}/view/${record._id}`} ><i className="fa fa-light fa-eye"></i>
              </Link>
            </Tooltip>

            <Tooltip title={"View " + sectionName} color={"purple"} key={"view" + 'vendors'}>
              <Button title="View" onClick={(e) => { setSelected(record); viewDealer(record._id); }}><i class="fas fa-people-carry"></i></Button>
            </Tooltip>
          </>
        );
      },
    },
  ];


  const getCategoryList = () => {
    request({
      url: api.category + "/" + 'product',
      method: 'GET',
      onSuccess: (data) => {
        setCategoryList(data.data);
      },
      onError: (error) => {
        console.log(error)
        ShowToast(error, Severty.ERROR)
      }
    })
  };

  useEffect(() => {
    setLoading(true)
    fetchData(pagination)
  }, [refresh, debouncedSearchText, categoryIds])


  const fetchData = (pagination, filters) => {
    const filterActive = filters ? filters.is_active : null

    request({
      url: api.list + `?categoryIds=${categoryIds ? categoryIds : ''}&status=${filterActive ? filterActive.join(',') : ''}&page=${pagination ? pagination.current : 1}&limit=${pagination ? pagination.pageSize : 10}&search=${debouncedSearchText}`,
      method: 'GET',
      onSuccess: (data) => {
        setLoading(false)
        setList(data.data.list.docs)
        setPagination(prev => ({ current: pagination.current, total: data.data.list.totalDocs }))
      },
      onError: (error) => {
        console.log(error)
        setLoading(false)
        ShowToast(error, Severty.ERROR)
      }
    })
  }

  const handleChange = (pagination, filters) => {
    fetchData(pagination, filters);
  }

  const onSearch = (e) => {
    setSearchText(e.target.value)
    setPagination({ current: 1 })
  };

  const handleReset = (e) => {
    setCategoryIds([])
  }

  const handleCategory = (e) => {
    setCategoryIds(e)
    setPagination(prev => ({ ...prev, current: 1 }))
  };

  useEffect(() => {
    getCategoryList()
  }, [])

  const excelData = list.map(row => ({
    "Thumbnail": row.thumbnail ? row.thumbnail : '-',
    "Name": row.name ? row.name : '-',
    "Category": row.category ? row.category.name : '-',
    "SKU": row.sku || '-',
    "Model Year": row.year_model || '-',
    "Price": row.price ? row.price : '-',
    "Type": row.type_id ? row.type_id.name : '-',
    "Make": row.make_id ? row.make_id.name : '-',
    "Model": row.model_id ? row.model_id.name : '-',
    "Variant": row.variant_id ? row.variant_id.name : '-',
    "Part Number": row.part_number ? row.part_number : '-',
    "Attributes": row.all_attribute?.map((atr) => {
      return `{Name: ${atr?.name}, Value: ${atr?.value}}`;
    }).join(', '),
    "Dealers": row?.dealers?.map((dl) => {
      return `{Name: ${dl?.user_id?.name}, Email: ${dl?.user_id?.email}}`;
    }).join(', '),
    "Status": row.is_active ? 'Active' : 'Inactive',
    "Status": row.is_active ? 'Active' : 'Inactive',
    "Featured": row.is_featured ? 'Yes' : 'No',
    "Description": row.description ? row.description?.replace(/<[^>]*>/g, '') : '-',
    "Created On": moment(row.created_at).format("DD-MM-YYYY"),
  }));

  return (
    <>
      <div className="tabled productCaralogue">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={sectionName + " Management"}
              extra={
                <>
                  <Search
                    allowClear
                    size="large"
                    onChange={onSearch}
                    value={searchText}
                    onPressEnter={onSearch}
                    placeholder="Search By Name"
                  />
                  <div className="button_group justify-content-end w-100">
                    <Link className="ant-btn ant-btn-primary" to={`/pimptup-admin/${routeName}/add`}>Add {sectionName}</Link>
                    <Button title="Export" onClick={(e) => DownloadExcel(excelData, sectionName)}><i class="fas fa-cloud-download-alt"></i>&nbsp;&nbsp;Export</Button>
                    <Button title="Import" onClick={(e) => { setImportVisible(true); setSearchText(''); }}><i class="fas fa-cloud-upload-alt"></i>&nbsp;&nbsp;Import</Button>
                  </div>
                </>
              }
            >

              <Row gutter={[24, 0]} className="mb-24">
                <Col xs={16} xl={16} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <div className="selectQuote" style={{ display: "flex", alignItems: "end", gap: "8px", width: "100%" }}>
                    <Select showSearch style={{ width: '100%' }} value={categoryIds} placeholder="Filter By Category (Multiple)" mode="multiple" name="categrory_id" onChange={handleCategory}
                      filterOption={(input, option) =>
                        (option.label ?? '').toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {categoryList && categoryList.length > 0 ? categoryList.map((item, index) => (
                        <Select.Option key={index} value={item._id} label={item.name}> {item.name} </Select.Option>
                      )) : null}
                    </Select>
                  </div>

                  <Button onClick={handleReset}><i class="fas fa-sync-alt"></i></Button>
                </Col>
              </Row>

              <h4 className="text-right mb-1">{pagination.total ? ShowTotal(pagination.total) : ShowTotal(0)}</h4>
              <div className="table-responsive customPagination">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{ defaultPageSize: 10, responsive: true, total: pagination.total, showSizeChanger: true, pageSizeOptions: ['10', '20', '30', '50'] }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>

      {importVisible && <ImportForm path={api.importFile} sectionName={sectionName} show={importVisible} hide={() => setImportVisible(false)} existingData={list} refresh={() => setRefresh(prev => !prev)} />}

      {visible && <ViewDealer path={api.viewProductDealer} show={visible} hide={() => { setSelected(); setVisible(false) }} data={selected} />}

    </>
  );
}

export default Index;
